import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { ProficiencyService } from '../../../../../../../services/proficiency/proficiency.service';
import { Proficiency } from '../../../../../../../models/proficiency';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-edit-proficiency-modal',
  templateUrl: './edit-proficiency-modal.component.html',
  styleUrls: ['./edit-proficiency-modal.component.css']
})
export class EditProficiencyModalComponent implements OnInit {

  @Input() proficiency: Proficiency;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public hasNoCheckInExpirationMonths = false;
  public hasExpirationAfterGrantedByDocumentDays = false;

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public proficiencyService: ProficiencyService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }

    if (this.proficiency.no_check_in_expiration_months !== null) {
      this.hasNoCheckInExpirationMonths = true;
    }
    if (this.proficiency.expiration_after_granted_by_document_days !== null) {
      this.hasExpirationAfterGrantedByDocumentDays = true;
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    if (!this.hasNoCheckInExpirationMonths) {
      this.proficiency.no_check_in_expiration_months = null;
    }
    if (!this.hasExpirationAfterGrantedByDocumentDays) {
      this.proficiency.expiration_after_granted_by_document_days = null;
    }

    this.proficiencyService
      .updateProficiency(this.proficiency)
      .then(updatedProficiency => {
        this.savedCallback({
          text: this.proficiency.name + ' saved successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit proficiencies.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
